import { useTranslation } from 'react-i18next';
import { DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { useDeactivateAccount } from '../../../hooks/use-account';

interface DeactivateAccountProps {
    onClose: () => void;
}
/// Its deletes the account parmanently
export const DeactivateAccount = ({ onClose }: DeactivateAccountProps) => {
    const { t } = useTranslation();
    const { mutate: deactivateAccount, isPending } = useDeactivateAccount({ isDeleteForever: true });

    const handleDeactivate = () => {
        deactivateAccount(undefined, {
            onSuccess: () => {
                onClose();
            },
        });
    };

    return (
        <DialogContent nested className="sm:max-w-[540px]">
            <DialogHeader>
                <DialogTitle className="text-destructive">{t('DELETE_ACCOUNT')}</DialogTitle>
                <DialogDescription asChild className="text-medium-emphasis">
                    <div className="flex flex-col gap-3 text-sm">
                        <p>
                            {t('DELETE_ACCOUNT_WARNING') ||
                                'Are you sure you want to delete your account?'}
                        </p>
                        <p>
                            {t('DELETE_ACCOUNT_DEACTIVATION_DETAILS') ||
                                'Your account will be deactivated immediately and you will be permanently logged out from your account. All associated data will be permanently deleted after 30 days.'}
                        </p>
                        <p>
                            {t('DELETE_ACCOUNT_IRREVERSIBLE_NOTICE') ||
                                'This action cannot be undone once the 30-day period has passed.'}
                        </p>
                    </div>
                </DialogDescription>
            </DialogHeader>
            <DialogFooter>
                <Button
                    variant="ghost"
                    onClick={onClose}
                    className="text-medium-emphasis hover:text-high-emphasis"
                >
                    {t('CANCEL')}
                </Button>
                <Button
                    variant="destructive"
                    onClick={handleDeactivate}
                    disabled={isPending}
                >
                    {isPending ? t('DELETING') : t('DELETE_ACCOUNT')}
                </Button>
            </DialogFooter>
        </DialogContent>
    );
}; 